import React from 'react'
import { Loader, Dimmer } from 'semantic-ui-react'

const LoadingComponent: React.FC<{ inverted?: boolean, content?: string, active?: boolean }> = ({
    inverted = true,
    content,
    active
}) => {
    return (
        <Dimmer active={active} inverted={inverted}>
            <Loader content={content} />
        </Dimmer>
    )
}

export default LoadingComponent